import * as React from 'react';
import {
    AutocompleteInput, ReferenceField, ReferenceInput,
    ReferenceManyField,
    TextField,
    TextInput, useRecordContext, useUpdate,
    SelectField, FormDataConsumer,
    SelectInput
} from 'react-admin';
import {Grid, Typography} from "@material-ui/core";

import {EditableDatagrid, RowForm} from "@react-admin/ra-editable-datagrid";
import useMyStyles from "../utils/useMyStyles";
import {DateFieldComp, DateInputComp, NumberInputFloatComp} from "../_common/CompReact";
import {validateReq} from "../utils/validateTable";
import {FloatNumber, formatSpacerNumber} from "./BookingColumnsForList";
import {useEffect} from "react";
import get from "lodash/get";
import Box from "@material-ui/core/Box";
import {useForm} from "react-final-form";
//import set from "lodash/set";

const transform = (data) => {
    console.log('Transform========>', data)


    data.cost_miles_price_dollar = data.cost_miles_price_dollar2
    delete data.cost_miles_price_dollar2

    data.sale_miles_price_dollar = data.sale_miles_price_dollar2
    delete data.sale_miles_price_dollar2

    data.payment_type = data.payment_type2
    delete data.payment_type2
    // localStorage.removeItem('fdsBookingForm');
    if (data.date === undefined) data.date = null
    if (data.date_to === undefined) data.date_to = null
    if (data.date_to && !data.date) {
        data.date = data.date_to
        data.date_to = null
    }
    return data;
}

/*
non_flight - booking type transaction

we  just need

Customer
Passenger
Non-Flight Transaction Type: Transaction Type

Supplier
and notes
*/

const InputMilesCash = (props) => {
    const {formData} = props;
    const formEdit = useForm();


    useEffect(() => {

        console.log('formData--2---->', formData)
        if (formData.payment_type2) {
            if (formData.payment_type2 === 'miles') {
                let miles_quantity = 0
                let cost_miles_price_dollar2 = 0
                let sale_miles_price_dollar2 = 0

                if (formData.miles_quantity >= 0) miles_quantity = formData.miles_quantity
                else formEdit.change('miles_quantity', '')

                if (formData.cost_miles_price_dollar2 >= 0) cost_miles_price_dollar2 = formData.cost_miles_price_dollar2
                else formEdit.change('cost_miles_price_dollar2', '')

                if (formData.sale_miles_price_dollar2 >= 0) sale_miles_price_dollar2 = formData.sale_miles_price_dollar2
                else formEdit.change('sale_miles_price_dollar2', '')

                let res = miles_quantity * cost_miles_price_dollar2
                formEdit.change('cost_amount_dollar', res)
                res = miles_quantity * sale_miles_price_dollar2
                formEdit.change('amount_dollar', res)
            }
        } else {
            formEdit.change('payment_type2', 'cash')
        }

    }, [formData.payment_type2, formData.miles_quantity, formData.sale_miles_price_dollar2, formData.cost_miles_price_dollar2]) // eslint-disable-line

    return (
        <Box display={'grid'}>
            <SelectInput source="payment_type2" choices={[
                {id: 'cash', name: 'Cash'},
                {id: 'miles', name: 'Miles'},
            ]}/>
            {formData.payment_type2 === 'miles' &&
            <NumberInputFloatComp style={{maxWidth: 130, marginTop: '-16px'}}
                                  source="miles_quantity" label={'Miles quantity'} validate={validateReq}/>
            }

        </Box>
    )
}
const InputCost = (props) => {
    const {formData} = props;
    return (
        <Box display={'grid'}>
            {formData.payment_type2 === 'miles'
                ?
                <Box display={'grid'}>
                    <Box style={{fontWeight: "bold"}}
                         textAlign={"right"}>{formatSpacerNumber(formData.cost_amount_dollar, ',', 2)}</Box>
                    {/*<FloatNumber source={'cost_amount_dollar'} textAlign={"right"}/>*/}
                    <NumberInputFloatComp style={{maxWidth: 120}}
                                          source="cost_miles_price_dollar2" label={'Miles price'}
                                          validate={validateReq}/>
                </Box>
                :
                <NumberInputFloatComp style={{maxWidth: 120}}
                                      source="cost_amount_dollar" label={'Amount'} validate={validateReq}/>
            }

        </Box>
    )
}
const InputSale = (props) => {
    const {formData} = props;
    return (
        <Box display={'grid'}>
            {formData.payment_type2 === 'miles'
                ?
                <Box display={'grid'}>
                    <Box style={{fontWeight: "bold"}}
                         textAlign={"right"}>{formatSpacerNumber(formData.amount_dollar, ',', 2)}</Box>
                    {/*<TextField style={{maxWidth: 120}} source="amount_dollar"/>*/}
                    <NumberInputFloatComp style={{maxWidth: 120}}
                                          source="sale_miles_price_dollar2" label={'Miles price'}
                                          validate={validateReq}/>
                </Box>
                :
                <NumberInputFloatComp style={{maxWidth: 120}}
                                      source="amount_dollar" label={'Sale Amount ($)'} validate={validateReq}/>
            }

        </Box>
    )
}

const ListEditForm = (props) => {
    const {booking_id, record} = props;

    //console.log('PROPS-------->', props)

    return (
        <RowForm  {...props}
                  transform={transform}
                  initialValues={{
                      booking_id: booking_id,
                      payment_type2: record.payment_type,
                      cost_miles_price_dollar2: record.cost_miles_price_dollar,
                      sale_miles_price_dollar2: record.sale_miles_price_dollar
                  }}
                  style={{verticalAlign: "top"}}
        >
            <ReferenceInput
                sort={{field: 'value', order: 'ASC'}}
                source="value_id" reference="non_flight_transactions"
                label={'Type'}
                validate={validateReq}>
                <AutocompleteInput
                    resettable
                    optionText="value"
                    // defaultValue={parseInt(customer_id) ? parseInt(customer_id) : null}
                />
            </ReferenceInput>
            <TextInput source={'notes'} label={'Notes'} multiline style={{maxWidth: 150}}/>

            <FormDataConsumer>
                {({formData, ...rest}) => {
                    return (
                        <InputMilesCash formData={formData}/>
                    )
                }}
            </FormDataConsumer>
            <FormDataConsumer>
                {({formData, ...rest}) => {
                    return (
                        <InputCost formData={formData}/>
                    )
                }}
            </FormDataConsumer><FormDataConsumer>
            {({formData, ...rest}) => {
                return (
                    <InputSale formData={formData}/>
                )
            }}
        </FormDataConsumer>

            {/*<NumberInputFloatComp style={{maxWidth: 120}}
                                  source="cost_amount_dollar" label={'Amount'} validate={validateReq}/>
            <NumberInputFloatComp style={{maxWidth: 130}}
                                  source="amount_dollar" label={'Sale Amount ($)'} validate={validateReq}/>*/}

            <TextInput source={'route'} label={'Route'} multiline style={{maxWidth: 150}}/>
            {/*<NumberInputFloatComp source="profit" label={'Profit ($)'}/>*/}
            <DateInputComp source={"date"} label={"Date"} style={{maxWidth: 130}}/>
            <DateInputComp source={"date_to"} label={"Date to"} style={{maxWidth: 130}}/>

            <GetProfit label={'Profit ($)'} textAlign={"right"} style={{maxWidth: 120}}/>
            {/*<FormDataConsumer>
                {({formData, ...rest}) => {
                    return (
                        <NumberInputFloatComp source={'amount_dollar'} Label={'Amount ($)'}/>
                    )
                }}
            </FormDataConsumer>*/}
        </RowForm>
    )

};

const GetProfit = (props) => {
    //const {classes} = props;
    const record = useRecordContext(props);
    let profit = 0;
    let cost_amount_dollar = get(record, 'cost_amount_dollar', null);
    let amount_dollar = get(record, 'amount_dollar', null);
    if (amount_dollar && cost_amount_dollar) profit = amount_dollar - cost_amount_dollar;
    return (
        <span>{formatSpacerNumber(profit)}</span>
    )
}
const GetMilesCash = (props) => {
    //const {classes} = props;
    const record = useRecordContext(props);
    return (
        <Box display={'grid'}>
            {record.payment_type
                ?
                <SelectField source="payment_type" choices={[
                    {id: 'cash', name: 'Cash'},
                    {id: 'miles', name: 'Miles'},
                ]}/>
                :
                <Box>{'Cash'}</Box>
            }
            {record.payment_type === 'miles' &&
            <FloatNumber source={'miles_quantity'} label={'Miles quantity'} textAlign={"right"}/>
            }

        </Box>
    )
}

const GetAmount = (props) => {
    const {source} = props;
    const record = useRecordContext(props);
    let amount = 'amount_dollar'
    let miles_price = 'sale_miles_price_dollar'
    if (source === 'cost') {
        amount = 'cost_amount_dollar'
        miles_price = 'cost_miles_price_dollar'
    }
    return (
        <Box display={'grid'} label={'Miles quantity'}>
            {record.payment_type === 'miles'
                ?
                <Box display={'grid'}>
                    <TextField source={miles_price} textAlign={"right"}/>
                    <FloatNumber source={amount} textAlign={"right"}/>
                </Box>
                :
                <FloatNumber source={amount} textAlign={"right"}/>
            }

        </Box>
    )
}

const TableDtGr = (props) => {
    const {booking_id, classes, data, setTotal, loaded} = props;

    useEffect(() => {
        if (loaded) {
            let sale_amount = 0;
            let cost_amount = 0;
            if (data) {
                //console.log('BookingNonFlightTransactions====loaded=======>', loaded)
                Object.entries(data).forEach(([key, value]) => {
                    sale_amount += value.amount_dollar;
                    cost_amount += value.cost_amount_dollar;
                });
            }
            setTotal({
                loaded: true,
                saleTotal: sale_amount,
                costTotal: cost_amount
            })
        }
    }, [data, loaded]) // eslint-disable-line


    return (
        <EditableDatagrid
            {...props}
            /*data={data}
            total={total}*/
            classes={{headerCell: classes.headerCell, row: classes.row, rowCell: classes.rowCell}}
            //noDelete={true}
            /*onChange={(data) => {
                console.log('===fdsBookingForm==========>', data)
                // localStorage.setItem('fdsBookingForm', JSON.stringify(formData));
            }}*/
            mutationMode="pessimistic" //Подтвердить удаление
            undoable
            createForm={<ListEditForm submitOnEnter={false} booking_id={booking_id}/>}
            editForm={<ListEditForm submitOnEnter={false} booking_id={booking_id}/>}
            //rowStyle={postRowStyle}
        >
            <ReferenceField source="value_id" reference="non_flight_transactions" label={'Type'}
                            link={false} textAlign={"left"}>
                <TextField source="value"/>
            </ReferenceField>

            <TextField source={'notes'} label={'Notes'}/>

            <GetMilesCash label={'Miles / Cash'}/>

            <GetAmount source={'cost'} label={'Cost Amount ($)'} textAlign={"right"}/>

            <GetAmount source={'sale'} label={'Sale Amount ($)'} textAlign={"right"}/>

            <TextField source={'route'} label={'Route'}/>
            <DateFieldComp source="date" label={'Date'}
                           headerClassName={classes.date_st} cellClassName={classes.date_st} showTime={false}
                           locale={'us'}/>
            <DateFieldComp source="date_to" label={'Date To'}
                           headerClassName={classes.date_st} cellClassName={classes.date_st} showTime={false}
                           locale={'us'}/>
            <GetProfit label={'Profit ($)'} textAlign={"right"}/>
        </EditableDatagrid>
    )
};

const BookingNonFlightTransactions = props => {
    const {booking_id, formData} = props;

    const classes = useMyStyles();
    // const [update, { isLoading, error }] = useUpdate();
    const [update] = useUpdate();
    const [total, setTotal] = React.useState({
        loaded: false,
        saleTotal: 0,
        costTotal: 0,
    });
    useEffect(() => {
        if (total.loaded) {
            if (formData.cost_total_dollar !== total.costTotal || formData.sale_total_dollar !== total.saleTotal) {
                //formEdit.change('sale_total_dollar', total.saleTotal)
                //formEdit.change('cost_total_dollar', total.costTotal)
                //console.log(booking_id, 'BookingNonFlightTransactions===========>', total)
                update(
                    'booking',
                    booking_id,
                    {sale_total_dollar: total.saleTotal, cost_total_dollar: total.costTotal},
                    {sale_total_dollar: formData.sale_total_dollar, cost_total_dollar: formData.cost_total_dollar},
                );
            }
        }
    }, [total]) // eslint-disable-line

    /*useEffect(() => {
        if (id) {
            setTimeout(function () {
                setStartExchangeRate({fee: true, tax: true, amountTax: true, amountFee: true,})
            }, 500);
        }
    }, [id]);// eslint-disable-line*/

    // const redirect = useRedirect()

    /*const { data, total, isLoading } = useGetList('travelCredit',
        { page: 1, perPage: 10 },
        {},
        { filter: {booking_id: booking_id}},
    );
    if (isLoading) return null;
    console.log('data======>', data)*/

    //let data = []; let total = 0;
    return (
        <>
            <Grid item xs={12} className={classes.booking_title}>
                <Typography variant="h6" gutterBottom>
                    Non Flight Cat.
                </Typography>
            </Grid>
            <div style={{width: "max-content", minWidth: 500, marginBottom: 16}}>
                <ReferenceManyField
                    //fullWidth
                    label=" "
                    reference="bookings_non_flight_transactions"
                    target="booking_id"
                >
                    <TableDtGr classes={classes} booking_id={booking_id} setTotal={setTotal}/>
                </ReferenceManyField>

                <Grid container style={{marginTop: 24, textAlign: "end"}}>
                    <Grid item xs={6}>
                        <div className={classes.cost_show_field_calc}>
                            <div>
                                <span style={{fontSize: 12}}>{'Cost Total Amount ($)'}</span>
                            </div>
                            <div>
                                <span>{formatSpacerNumber(total.costTotal)}</span>
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={3}>
                        <div className={classes.cost_show_field_calc}>
                            <div>
                                <span style={{fontSize: 12}}>{'Sale Total Amount ($)'}</span>
                            </div>
                            <div>
                                <span>{formatSpacerNumber(total.saleTotal)}</span>
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={3} style={{textAlign: "center"}}>
                        <div className={classes.cost_show_field_calc}>
                            <div>
                                <span style={{fontSize: 12}}>{'Profit ($)'}</span>
                            </div>
                            <div>
                                <span>{formatSpacerNumber(total.saleTotal - total.costTotal)}</span>
                            </div>
                        </div>
                    </Grid>
                </Grid>

            </div>
        </>
    )
}
export default BookingNonFlightTransactions;